
const mainProductGallery = document.querySelector('.product__gallery-main');

if (mainProductGallery) {
    const swiper = new Swiper(mainProductGallery, {
        slidesPerView: 1,
        centeredSlides: false,
        spaceBetween: 20,
        loop: true,
        navigation: {
            nextEl: mainProductGallery.querySelector('.product__gallery-btn-next'),
            prevEl: mainProductGallery.querySelector('.product__gallery-btn-prev'),
        },
    });

    document.addEventListener('click', (event) => {
        const target = event.target;
        
        if (target.closest('.product__gallery-thumb')) {
            const thumb = target.closest('.product__gallery-thumb');
            const index = thumb.dataset.index;
            swiper.slideTo(index);
            
            thumb.classList.add('product__gallery-thumb--active');
        }
    });

    swiper.on('slideChange', (event) => {
        const activeIndex = event.realIndex;
        const newActiveThumb = document.querySelector(`.product__gallery-thumbs .product__gallery-thumb[data-index="${activeIndex}"]`);
        const activeThumb = document.querySelector('.product__gallery-thumbs .product__gallery-thumb--active');

        if (activeThumb) {
            activeThumb.classList.remove('product__gallery-thumb--active');
        }
        newActiveThumb.classList.add('product__gallery-thumb--active');
    });
    
}